import React from 'react';
import { Slider as MuiSlider } from '@material-ui/core';

const Slider = props => <MuiSlider {...props} />;

export default Slider;
